// src/utils/tarjouspyynnot/providerApi.js
// Betonijerry transport binding for @ibetoni/jerry-client (operator pages).
// Mirrors valutApi.js philosophy: GETs throw with `.status` on non-2xx
// (callers handle 401 → logout, 403 → not-a-provider). Writes resolve the
// package's { success, error?, data } contract instead of throwing, except
// 401 which propagates so callers can logout.

import { createTarjouspyyntoApi } from "@ibetoni/jerry-client";
import { API_URL } from "src/utils/apiUrl";
import { authHeaders, jsonOrThrow } from "src/utils/apiFetch";

export function providerApi(token) {
    const mutate = async (path, { method = "POST", body } = {}) => {
        try {
            const res = await fetch(`${API_URL}${path}`, {
                method,
                headers: { "Content-Type": "application/json", ...authHeaders(token) },
                body: body != null ? JSON.stringify(body) : undefined,
            });
            const data = await jsonOrThrow(res);
            return { success: true, data };
        } catch (err) {
            if (err.status === 401) throw err;
            return { success: false, error: err.body?.message || err.message, status: err.status };
        }
    };
    return {
        ...createTarjouspyyntoApi({
            // _opts carries the catalog's { fallback } hint — betonijerry's transport
            // deliberately throws instead of resolving fallbacks (callers catch).
            query: async (path, _opts) => {
                const res = await fetch(`${API_URL}${path}`, { headers: authHeaders(token) });
                return jsonOrThrow(res);
            },
            mutate,
        }),
        // Provider withdraws its own sent ('pending') offer before the customer
        // accepts it → 'withdrawn' (Päättyneet). Not in @ibetoni/jerry-client:
        // betonijerry is its only caller. 409 once the offer is no longer pending.
        withdrawOffer: (pumppuRequestId, pumppuOfferId) =>
            mutate(`/api/pumppuRequests/${pumppuRequestId}/offers/${pumppuOfferId}/withdraw`, { method: "POST", body: {} }),
    };
}
